var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-btn',{class:['ld-ext-right', { running: _vm.loading }],attrs:{"type":_vm.type,"variant":_vm.variant,"disabled":_vm.loading},on:{"click":_vm.handleClick}},[_vm._t("default"),_c('div',{staticClass:"ld ld-ring ld-spin"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }